import React from "react";
import {
  MainStyled,
  MenueButton,
  Header,
  HeaderText,
} from "./WithMainContainer.styles";
import { Link } from "react-router-dom";
import HomeIcn from "../../assets/img/img_home.svg";
import BackIcon from "../../assets/img/backIcon";
const WithMainContainer = (Comp) => () => {
  // console.log(Comp);
  console.log(window.location.pathname.includes("/app2/reqs"));
  const Url = window.location.pathname;
  const HeaderStep = () => {
    switch (Url) {
      case "/app2/reqs":
        return <HeaderText>درخواست ها</HeaderText>;
      case "/app2/without":
        return <HeaderText> همه درخواست ها</HeaderText>;
      case "/app2/wallet":
        return <HeaderText>اعتبار </HeaderText>;
      case "/app2/messages":
        return <HeaderText>صندوق پیام</HeaderText>;
      case "/app2/support":
        return <HeaderText>پشتیبانی</HeaderText>;
      case "/app2/jeton":
        return <HeaderText>ژتون</HeaderText>;
      case "/app2/user-info":
        return <HeaderText>اطلاعات فردی</HeaderText>;
      default:
        return null;
    }
  };
  return (
    <MainStyled>
      <Header
        style={{
          display: window.location.pathname.includes("/app2/new-req")
            ? "none"
            : "flex",
        }}
      >
        <div>{HeaderStep()}</div>
        {["/app2/vehicle-category"].includes(window.location.pathname) && (
          <button onClick={() => window.history.back()}>
            <BackIcon />
          </button>
        )}
        <MenueButton
          right={["/app2/vehicle-category", "/app2/new-req"].includes(
            window.location.pathname
          )}
        >
          <Link className="d-flex" to="/app2/home">
            <img src={HomeIcn} alt="img"></img>
          </Link>
        </MenueButton>
      </Header>

      <Comp />
    </MainStyled>
  );
};

export default WithMainContainer;
